import { BaseService } from "./BaseService";

export class AppVariablesService extends BaseService {
  constructor() {
    super("/app-variables");
  }

  async updateVariable(body) {
    try {
      const response = await this.getClient().put(`/app-variables`, body);

      return response.data;
    } catch (error) {
      this.handleError(error);
    }
  }
}
